import { Login, OauthCallback, PrivateOutlet } from '@chocolate-soup-inc/cs-frontend-components';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from '../pages/shared/Layout';
import {
  ACCOUNT_PATH,
  CLIENT_ONE_OFF_PATH,
  CLIENT_ONE_OFF_PATH_NEW,
  COMPANIES_PATH,
  COMPANIES_PATH_NEW,
  COMPANY_PATH,
  DEPENDANTS_PATH,
  DETAILS_PATH,
  EDIT_PATH,
  EMPLOYEES_PATH,
  EMPLOYEES_PATH_NEW,
  EMPLOYEE_PATH,
  ENTITY_GIFTS_PATH,
  EVENTS_PATH,
  GIFTS_PATH,
  GIFT_PACKAGES_PATH,
  GIFT_PATH,
  GIFT_PRODUCTS_PATH,
  HOME_PATH,
  HOME_PATH_NEW,
  IMPORT_LIST_PATH,
  IMPORT_LIST_PATH_NEW,
  IMPORT_PATH,
  INVITE_PATH,
  LOGIN_PATH,
  LOGS_PATH,
  LOGS_PATH_NEW,
  NEW_HIRES_PATH,
  NEW_HIRES_PATH_NEW,
  NEW_PATH,
  OAUTH_CALLBACK_PATH,
  OFFICE_PATH,
  OFFICE_PATH_NEW,
  ONE_OFF_PATH,
  ONE_OFF_PATH_NEW,
  ORPHAN_PATH,
  ORPHAN_PATH_NEW,
  PACKAGE_PATH,
  PRODUCT_PATH,
  REPORTS_PATH,
  ROOT_PATH,
  SET_FOR_PICKUP_PATH,
  SET_FOR_PICKUP_PATH_NEW,
  SHIPMENTS_PATH,
  SHIPMENTS_PATH_NEW,
  SHIPMENT_PATH,
  SKIPPED_PATH,
  SKIPPED_PATH_NEW,
  SUBSCRIPTIONS_PATH,
  SUBSCRIPTIONS_PATH_NEW,
  TRACKING_PATH,
  TRACKING_PATH_NEW,
  USERS_PATH
} from './paths';

import { Changelog } from '../pages/changelog/Changelog';
import { ChangelogNEW } from '../pages/changelog/ChangelogNEW';
import { Companies } from '../pages/companies/Companies';
import { CompaniesNEW } from '../pages/companies/CompaniesNEW';
import { CompanyCreate } from '../pages/companies/CompanyCreate';
import { CompanyDetails } from '../pages/companies/CompanyDetails';
import { CompanyPackages } from '../pages/companies/CompanyPackages';
import { CompanyUpdate } from '../pages/companies/CompanyUpdate';
import { CompanyUsers } from '../pages/companies/CompanyUsers';
import { CompanyUsersInvite } from '../pages/companies/CompanyUsersInvite';
import { EmployeeAccount } from '../pages/employees/EmployeeAccount';
import { EmployeeDependants } from '../pages/employees/EmployeeDependants';
import { EmployeeGifts } from '../pages/employees/EmployeeGifts';
import { Employees } from '../pages/employees/Employees';
import { EmployeesNEW } from '../pages/employees/EmployeesNEW';
import { Import } from '../pages/employees/import/Import';
import { ImportHistory } from '../pages/employees/ImportHistory';
import { ImportHistoryNEW } from '../pages/employees/ImportHistoryNEW';
import { ClientOneOffEvents } from '../pages/events/ClientOneOffEvents';
import { ClientOneOffEventsNEW } from '../pages/events/ClientOneOffEventsNEW';
import { EventCreateForm } from '../pages/events/CreateOneOffEvent';
import { HomeEvents } from '../pages/events/HomeEvents';
import { HomeEventsNEW } from '../pages/events/HomeEventsNEW';
import { NewHireEvents } from '../pages/events/NewHireEvents';
import { NewHireEventsNEW } from '../pages/events/NewHireEventsNEW';
import { OfficeEvents } from '../pages/events/OfficeEvents';
import { OfficeEventsNEW } from '../pages/events/OfficeEventsNEW';
import { OneOffEvents } from '../pages/events/OneOffEvents';
import { OneOffEventsNEW } from '../pages/events/OneOffEventsNEW';
import { SkippedEvents } from '../pages/events/SkippedEvents';
import { SkippedEventsNEW } from '../pages/events/SkippedEventsNEW';
import { GiftDetails } from '../pages/giftAssembling/GiftDetails';
import { NewHireGifts } from '../pages/giftAssembling/NewHireGifts';
import { NewHireGiftsNEW } from '../pages/giftAssembling/NewHireGiftsNEW';
import { OneOffGifts } from '../pages/giftAssembling/OneOffGifts';
import { OneOffGiftsNEW } from '../pages/giftAssembling/OneOffGiftsNEW';
import { OrphanGifts } from '../pages/giftAssembling/OrphanGifts';
import { OrphanGiftsNEW } from '../pages/giftAssembling/OrphanGiftsNEW';
import { SubscriptionGifts } from '../pages/giftAssembling/SubscriptionGifts';
import { SubscriptionGiftsNEW } from '../pages/giftAssembling/SubscriptionGiftsNEW';
import { GiftPackageCreate } from '../pages/giftPackages/GiftPackageCreate';
import { GiftPackageDetails } from '../pages/giftPackages/GiftPackageDetails';
import { GiftPackages } from '../pages/giftPackages/GiftPackages';
import { GiftProductCreate } from '../pages/giftProducts/GiftProductCreate';
import { GiftProducts } from '../pages/giftProducts/GiftProducts';
import { GiftProductUpdate } from '../pages/giftProducts/GiftProductUpdate';
import { EventsReport } from '../pages/reports/EventsReport';
import { FinancialReport } from '../pages/reports/FinancialReport';
import { GiftReports } from '../pages/reports/GiftReports';
import { ShipmentsReport } from '../pages/reports/ShipmentsReport';
import { ShipmentModalDetails } from '../pages/shipments/ShipmentModal/ShipmentModalDetails';
import { ShipmentModalGifts } from '../pages/shipments/ShipmentModal/ShipmentModalGifts';
import { Shipments } from '../pages/shipments/Shipments';
import { ShipmentsNEW } from '../pages/shipments/ShipmentsNEW';
import { ShipmentsSetForPickup } from '../pages/shipments/ShipmentsSetForPickup';
import { ShipmentsSetForPickupNEW } from '../pages/shipments/ShipmentsSetForPickupNEW';
import { ShipmentsTracking } from '../pages/shipments/ShipmentsTracking';
import { ShipmentsTrackingNEW } from '../pages/shipments/ShipmentsTrackingNEW';

export const AppRoutes = () => {
  const COMPANY_DETAILS = () => (
    <>
      <Route path={COMPANY_PATH}>
        <Route path='' element={<Navigate to={DETAILS_PATH} replace={true} />} />
        <Route path={DETAILS_PATH} element={<CompanyDetails />} />
        <Route path={USERS_PATH}>
          <Route path='' element={<CompanyUsers />} />
          <Route path={INVITE_PATH} element={<CompanyUsersInvite />} />
        </Route>
        <Route path={GIFT_PACKAGES_PATH} element={<CompanyPackages />} />
        <Route path={EDIT_PATH} element={<CompanyUpdate />} />
      </Route>
    </>
  );

  const EMPLOYEE_DETAILS = () => (
    <>
      <Route path={EMPLOYEE_PATH}>
        <Route path='' element={<Navigate to={ACCOUNT_PATH} replace={true} />} />
        <Route path={ACCOUNT_PATH} element={<EmployeeAccount />} />
        <Route path={DEPENDANTS_PATH} element={<EmployeeDependants />} />
        <Route path={ENTITY_GIFTS_PATH} element={<EmployeeGifts />} />
      </Route>
    </>
  );

  const SUBSCRIPTION_EVENTS = () => (
    <>
      <Route path='' element={<Navigate to={HOME_PATH} replace={true} />} />
      <Route path={HOME_PATH} element={<HomeEvents />} />
      <Route path={HOME_PATH_NEW} element={<HomeEventsNEW />} />
      <Route path={OFFICE_PATH} element={<OfficeEvents />} />
      <Route path={OFFICE_PATH_NEW} element={<OfficeEventsNEW />} />
    </>
  );

  const NEW_HIRE_EVENTS = () => (
    <>
      <Route path={NEW_HIRES_PATH} element={<NewHireEvents />} />
      <Route path={NEW_HIRES_PATH_NEW} element={<NewHireEventsNEW />} />
    </>
  );

  const ONE_OFF_EVENTS = () => (
    <>
      <Route path={ONE_OFF_PATH}>
        <Route path='' element={<OneOffEvents />} />
        <Route path={NEW_PATH} element={<EventCreateForm />} />
      </Route>
      <Route path={ONE_OFF_PATH_NEW} element={<OneOffEventsNEW />} />
      <Route path={CLIENT_ONE_OFF_PATH} element={<ClientOneOffEvents />} />
      <Route path={CLIENT_ONE_OFF_PATH_NEW} element={<ClientOneOffEventsNEW />} />
    </>
  );

  const SKIPPED_EVENTS = () => (
    <>
      <Route path={SKIPPED_PATH} element={<SkippedEvents />} />
      <Route path={SKIPPED_PATH_NEW} element={<SkippedEventsNEW />} />
    </>
  );

  const GIFT_DETAILS = () => (
    <>
      <Route path={GIFT_PATH} element={<GiftDetails />} />
    </>
  );

  const SUSBCRIPTION_GIFTS = () => (
    <>
      <Route path='' element={<Navigate to={SUBSCRIPTIONS_PATH} replace={true} />} />
      <Route path={SUBSCRIPTIONS_PATH}>
        <Route path='' element={<SubscriptionGifts />} />
        {GIFT_DETAILS()}
      </Route>
      <Route path={SUBSCRIPTIONS_PATH_NEW} element={<SubscriptionGiftsNEW />}>
        <Route path='' element={<SubscriptionGiftsNEW />} />
        {GIFT_DETAILS()}
      </Route>
      <Route path={ORPHAN_PATH} element={<OrphanGifts />} />
      <Route path={ORPHAN_PATH_NEW} element={<OrphanGiftsNEW />} />
    </>
  );

  const NEW_HIRE_GIFTS = () => (
    <>
      <Route path={NEW_HIRES_PATH}>
        <Route path='' element={<NewHireGifts />} />
        {GIFT_DETAILS()}
      </Route>
      <Route path={NEW_HIRES_PATH_NEW} element={<NewHireGiftsNEW />}>
        <Route path='' element={<NewHireGiftsNEW />} />
        {GIFT_DETAILS()}
      </Route>
    </>
  );

  const ONE_OFF_GIFTS = () => (
    <>
      <Route path={ONE_OFF_PATH}>
        <Route path='' element={<OneOffGifts />} />
        {GIFT_DETAILS()}
      </Route>
      <Route path={ONE_OFF_PATH_NEW} element={<OneOffGiftsNEW />}>
        <Route path='' element={<OneOffGiftsNEW />} />
        {GIFT_DETAILS()}
      </Route>
    </>
  );

  const SHIPMENT_DETAILS = () => (
    <>
      <Route path={SHIPMENT_PATH}>
        <Route path='' element={<Navigate to={DETAILS_PATH} replace={true} />} />
        <Route path={DETAILS_PATH} element={<ShipmentModalDetails />} />
        <Route path={ENTITY_GIFTS_PATH} element={<ShipmentModalGifts />} />
      </Route>
    </>
  );

  const GIFT_PACKAGES = () => (
    <>
      <Route path='' element={<GiftPackages />} />
      <Route path={NEW_PATH} element={<GiftPackageCreate />} />
      <Route path={PACKAGE_PATH}>
        <Route path='' element={<GiftPackageDetails />} />
        <Route path={DETAILS_PATH} element={<GiftPackageDetails />} />
      </Route>
    </>
  );

  const GIFT_PRODUCTS = () => (
    <>
      <Route path='' element={<GiftProducts />} />
      <Route path={NEW_PATH} element={<GiftProductCreate />} />
      <Route path={PRODUCT_PATH}>
        <Route path={EDIT_PATH} element={<GiftProductUpdate />} />
      </Route>
    </>
  );

  return (
    <Routes>
      <Route path={ROOT_PATH} element={<Navigate to={COMPANIES_PATH} replace={true} />} />
      <Route element={<PrivateOutlet loginPath={LOGIN_PATH} />}>
        <Route element={<Layout />}>
          <Route path={COMPANIES_PATH_NEW}>
            <Route path='' element={<CompaniesNEW />} />
            {COMPANY_DETAILS()}
          </Route>
          <Route path={COMPANIES_PATH}>
            <Route path='' element={<Companies />} />
            {COMPANY_DETAILS()}
            <Route path={NEW_PATH} element={<CompanyCreate />} />
            <Route path={REPORTS_PATH} element={<FinancialReport />} />
          </Route>
          <Route path={EMPLOYEES_PATH_NEW}>
            <Route path='' element={<EmployeesNEW />} />
            {EMPLOYEE_DETAILS()}
          </Route>
          <Route path={EMPLOYEES_PATH}>
            <Route path='' element={<Employees />} />
            {EMPLOYEE_DETAILS()}
            <Route path={IMPORT_PATH} element={<Import />} />
            <Route path={IMPORT_LIST_PATH} element={<ImportHistory />} />
            <Route path={IMPORT_LIST_PATH_NEW} element={<ImportHistoryNEW />} />
          </Route>
          <Route path={LOGS_PATH} element={<Changelog />} />
          <Route path={LOGS_PATH_NEW} element={<ChangelogNEW />} />
          <Route path={EVENTS_PATH}>
            {SUBSCRIPTION_EVENTS()}
            {NEW_HIRE_EVENTS()}
            {ONE_OFF_EVENTS()}
            {SKIPPED_EVENTS()}
            <Route path={REPORTS_PATH} element={<EventsReport />} />
          </Route>
          <Route path={GIFTS_PATH}>
            {SUSBCRIPTION_GIFTS()}
            {NEW_HIRE_GIFTS()}
            {ONE_OFF_GIFTS()}
            <Route path={GIFT_PACKAGES_PATH}>{GIFT_PACKAGES()}</Route>
            <Route path={GIFT_PRODUCTS_PATH}>{GIFT_PRODUCTS()}</Route>
            <Route path={REPORTS_PATH} element={<GiftReports />} />
          </Route>
          <Route path={SHIPMENTS_PATH_NEW}>
            <Route path='' element={<ShipmentsNEW />} />
            {SHIPMENT_DETAILS()}
          </Route>
          <Route path={SHIPMENTS_PATH}>
            <Route path='' element={<Shipments />} />
            {SHIPMENT_DETAILS()}
            <Route path={TRACKING_PATH} element={<ShipmentsTracking />} />
            <Route path={TRACKING_PATH_NEW} element={<ShipmentsTrackingNEW />} />
            <Route path={SET_FOR_PICKUP_PATH} element={<ShipmentsSetForPickup />} />
            <Route path={SET_FOR_PICKUP_PATH_NEW} element={<ShipmentsSetForPickupNEW />} />
            <Route path={REPORTS_PATH} element={<ShipmentsReport />} />
          </Route>
        </Route>
      </Route>
      <Route path={LOGIN_PATH} element={<Login afterLoginPath={ROOT_PATH} />} />
      <Route path={OAUTH_CALLBACK_PATH} element={<OauthCallback afterOauthPath={ROOT_PATH} loginPath={LOGIN_PATH} />} />
    </Routes>
  );
};
